import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {RouterProvider, createBrowserRouter, Navigate} from 'react-router-dom';
import * as Sentry from '@sentry/react';

import App from './App';
import {store} from './app/store';
import './config/icons.css';
import {PageNotFound} from './components/claim-expired';
import {LocaleProvider} from './context/locale-context';

import OktaLoginInstructions from './components/tech-app/okta-login-instructions';
import TechAppTermsAndConditions from './components/tech-app/terms-and-conditions';
import TechAppDownloadPage from './components/tech-app/download-tech-app';
import TechAppDownloadIOS from './components/tech-app/download-ios';
import TechAppDownloadAndroid from './components/tech-app/download-android';

const router = createBrowserRouter([
  {
    path: '/tracking/:id',
    element: <App />,
  },
  {
    path: '/tracking/',
    element: <Navigate to="/tracking/404" replace />,
  },
  {
    path: '/tracking/404',
    element: <PageNotFound />,
  },
  {
    path: '*',
    element: <Navigate to="/tracking/404" replace />,
  },
  {
    path: '/techapp',
    element: <TechAppDownloadPage />,
  },
  {
    path: '/techapp/ios',
    element: <TechAppDownloadIOS />,
  },
  {
    path: '/techapp/android',
    element: <TechAppDownloadAndroid />,
  },
  {
    path: '/techapp/login',
    element: <OktaLoginInstructions />,
  },
  {
    path: '/techapp/terms',
    element: <TechAppTermsAndConditions />,
  },
]);

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_REACT_APP_ENV,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^https:\/\/repairs-dev\.fixt\.co/, /^https:\/\/repairs-model\.fixt\.co/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = createRoot(document.getElementById('root')!); // ! operator asserts that element with id "root" definitely exists

root.render(
  <React.StrictMode>
    <LocaleProvider>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </LocaleProvider>
  </React.StrictMode>
);
